const FACEBOOK_APP_ID = '1878837665573004'
const LINKEDIN_APP_ID = '77wnnwooqfip2v'

export { FACEBOOK_APP_ID, LINKEDIN_APP_ID }
